import axios from 'axios'
import i18n from '@/plugins/i18n'

export default {
  // Поиск фауны
  list (filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined) {
        filter += `${field}=${filters[field]}&`
      }
    }

    return axios.get(`${i18n.locale}/api/public/fauna/list/?${filter}`)
  },
  // Получение данных для поиска Фауны
  getFaunaData () {
    return axios.get(`${i18n.locale}/api/public/fauna/data`)
  },
  // Получение данных для отображения животных
  getFaunaView (id) {
    return axios.get(`${i18n.locale}/api/public/fauna/view/${id}`)
  },
  // Получение данных для отображения основных животных
  getMainFauna () {
    return axios.get(`${i18n.locale}/api/public/fauna/main`)
  }
}
